import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationInvitationRepliedView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderHeader() {
    if (this.props.currentUser) {
      return(
        <div className="page-xs12-head">
          <h1 className="page-title">{I18n.t('service.text_000510')}</h1>
          <p className="page-description">
            <span className="message-strong">{this.props.currentUser.email}</span> {I18n.t('service.text_000515')}<br />
            <span className="message-strong"></span>{I18n.t('service.text_000516')}<br />
            {I18n.t('service.text_000511')}
          </p>
        </div>
      );
    } else {
      return(
        <div className="page-xs12-head">
          <h1 className="page-title">{I18n.t('service.text_000510')}</h1>
          <p className="page-description">{I18n.t('service.text_000511')}</p>
        </div>
      );
    }
  }
  
  render() {
    const reservation = this.props.reservation;
    const room = reservation.room;

    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            {this.renderHeader()}
            <div className="row">
              <div className="col-sm-12 col-md-5">
                <div className="site-sidebar">
                  <a href={Routes.space_room_path(room.space.username, room.uid)}>
                    <div className="side-space__units">
                      <img src={SMFormatHelper.roomImageURL(room, {width: 630, height: 420, crop: 'pad', background: '#9c9c9c'})} alt={SMFormatHelper.roomNameWithSpace(room)} className="" />
                      <h2 className="side-space__units-title">{SMFormatHelper.roomNameWithSpace(room)}</h2>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-sm-12 col-md-7">
                <p className="contact__complete-text">{I18n.t('service.text_000512')}<br />{I18n.t('service.text_000513')}</p>
                <div className="complete-detail__btn contact__complete-detail">
                  <p className="mb20">{I18n.t('service.text_000514')}</p>
                  <a href={Routes.itinerary_path(reservation.uid)} className="button-blue pt15 pb15 w200">{I18n.t('service.label_000513')}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SMReservationInvitationRepliedView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationInvitationRepliedView.jsx